import f from './Footer.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import MarketplaceLogo from '/public/static/images/image_logo_full.svg';
import React, { useEffect, useState } from 'react';
import { Button, Flex, Tag } from 'antd';
import g from '../../general.module.scss';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/utils/hooks/useStores';
import { QueryService } from 'tkmp-lib/src/services/QueryService';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

const Footer = observer(() => {
    const LOCALIZATION = useLocalization();
    const {
        userStore: { USERNAME },
        modalsStore: { openRegisterForm },
    } = useStores();

    const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

    useEffect(() => {
        setIsAuthorized(USERNAME !== '');
    }, [USERNAME]);

    const currentYear = new Date().getUTCFullYear();

    const [isPendingStatus, setIsPendingStatus] = useState<boolean>(false);
    const [aliveModules, setAliveModules] = useState<any>();

    useEffect(() => {
        if (false && process.env.NEXT_PUBLIC_DEBUG === 'true') {
            setIsPendingStatus(true);
            const refreshInterval = setInterval(function () {
                QueryService.request(`/api/healthcheck`).then((answer) => {
                    setIsPendingStatus(false);
                    setAliveModules(answer);
                });
            }, 5000);

            return () => {
                clearInterval(refreshInterval);
            };
        }
    }, []);

    return (
        <Flex className={f.mainFooter}>
            {process.env.NEXT_PUBLIC_DEBUG === 'true' && (
                <div
                    style={{
                        position: 'absolute',
                        background: '#0b0b0c',
                        top: '8px',
                        left: '8px',
                        border: '1px solid gray',
                        maxHeight: '256px',
                        overflow: 'auto',
                    }}
                >
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    count:{' '}
                                    {aliveModules && !aliveModules.error
                                        ? Object.keys(aliveModules?.components?.service?.details)
                                              ?.length
                                        : 0}
                                </td>
                            </tr>
                            {aliveModules && !aliveModules.error ? (
                                Object.keys(aliveModules?.components?.service?.details)?.map(
                                    (key) => (
                                        <tr key={key}>
                                            <td>{key}</td>
                                            <td>
                                                <Tag
                                                    color={
                                                        aliveModules?.components?.service?.details[
                                                            key
                                                        ]?.status === 'UP' && !isPendingStatus
                                                            ? 'green'
                                                            : 'red'
                                                    }
                                                >
                                                    {isPendingStatus
                                                        ? 'PENDING'
                                                        : aliveModules?.components?.service
                                                              ?.details[key]?.status}
                                                </Tag>
                                            </td>
                                        </tr>
                                    ),
                                )
                            ) : (
                                <tr>
                                    <td>ERROR STATUS</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
            <div className={f.footerBlock}>
                <div className={f.footerGrid}>
                    <Image
                        className={f.footerLogo}
                        src={MarketplaceLogo}
                        sizes={'100%'}
                        alt={'LOGO'}
                    />
                    <div className={f.helpList}>
                        <div className={f.categoryBlock}>
                            <span>{LOCALIZATION.footer.forBuyers.title}</span>
                            <Link href={'/help?category=solveProblems'}>
                                {LOCALIZATION.footer.forBuyers.help}
                            </Link>
                        </div>
                        <div className={f.categoryBlock}>
                            <span>{LOCALIZATION.footer.forPartners.title}</span>
                            <Link
                                href={'/help?category=suppliers&page=instructionsForManufacturers'}
                            >
                                {LOCALIZATION.footer.forPartners.instructionForSuppliers}
                            </Link>
                            <Link href={`${process.env.NEXT_PUBLIC_DOMAIN_TNG}`}>
                                {LOCALIZATION.footer.forPartners.services}
                            </Link>
                        </div>
                        <div className={f.categoryBlock}>
                            <span>{LOCALIZATION.footer.us.title}</span>
                            <Link href={'/help?category=aboutProject'}>
                                {LOCALIZATION.footer.us.aboutProject}
                            </Link>
                            <Link href={'https://app.tdmexpert.ru/'}>TDM</Link>
                            <Link href={'/catalog'}>{LOCALIZATION.footer.us.catalog}</Link>
                            <Link href={'/contacts'}>{LOCALIZATION.footer.us.contacts}</Link>
                            <Link href={'/help?category=legalInformation'}>
                                {LOCALIZATION.footer.us.legalInformation}
                            </Link>
                        </div>
                    </div>
                    <div className={f.contactsList}>
                        <div>
                            <a href={'tel:+74954658680'}>+7 (495) 465-86-80</a>
                            <a href={'mailto:info@istokmw.ru'}>info@istokmw.ru</a>
                        </div>
                    </div>
                </div>
                <span className={f.lineDescription}>
                    © {currentYear} TKMP.Istok — {LOCALIZATION.footer.placeholder}
                </span>
            </div>
        </Flex>
    );
});

export default Footer;
